export const routes: Routes = {
  submissions: '/submissions',
  drafts: '/drafts',
  products: '/allProducts',
  audits: '/audits',
  productGroups: '/product-groups',
  product: '/product',
  createSubmission: '/createSubmission',
  changeBroadcast: '/change-broadcast',
};

interface Routes {
  submissions: string;
  products: string;
  drafts: string;
  audits: string;
  product: string;
  productGroups: string;
  createSubmission: string;
  changeBroadcast: string;
}

/** Public routes accessible without authentication */
export const publicRoutes = {
  broadcastOptOut: '/broadcast-recipient/:token/opt-out',
  broadcastOptIn: '/broadcast-recipient/:token/opt-in',
};

export const paths: Paths = {
  submissionSummary: 'submissionSummary',
  submissionTasks: 'submission-tasks',
  document: 'document',
  html: 'html',
  print: 'print',
  changeBroadcastSend: 'send',
};

interface Paths {
  submissionSummary: string;
  submissionTasks: string;
  document: string;
  html: string;
  print: string;
  changeBroadcastSend: string;
}
